<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <dark-Toggler class="d-none d-lg-block" />
      <div class="ml-1">
        <b-form-select v-model="kib" :options="kibOptions" size="lg" @change="changeKib" />
      </div>
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown right toggle-class="d-flex align-items-center dropdown-user-link" class="dropdown-user">
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ nama }}
            </p>
            <span v-if="unit != 'null'" class="user-status">{{ unit }}</span>
          </div>
          <b-avatar badge badge-variant="success" />
          <!-- <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="require('@/assets/images/avatars/13-small.png')"
            class="badge-minimal"
            badge-variant="success"
          /> -->
        </template>

        <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
          <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BAvatar,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import { ref } from '@vue/composition-api'
import apiReferensi from '@/composables/referensi'
// import auth from '@/libs/auth'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BAvatar,

    // Navbar Components
    DarkToggler,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => { },
    },
  },
  data() {
    return {
      kibOptions: [
        { text: 'KIB B', value: 'b' },
        { text: 'KIB C', value: 'c' },
        // { text: 'KIB E', value: 'e' },
        // { text: 'KIB I', value: 'i' },
      ],
    }
  },
  methods: {
    logout() {
      this.$cookies.remove('token')
      this.$cookies.remove('username')

      const allCookies = document.cookie.split(';');

      // Loop through cookies and remove each one
      allCookies.forEach(cookie => {
        const cookieName = cookie.split('=')[0].trim();
        this.$cookies.remove(cookieName);
      });

      localStorage.removeItem('userData')
      this.$ability.update([
        {
          action: 'read',
          subject: 'Auth',
        },
      ])

      this.$router.replace({ name: 'login' })
      window.location.reload();
    },
  },
  setup(props, context) {
    const g = context.root

    // clearInterval(g.$store.state.global.idInterval)
    // let refreshToken = ref(auth.refreshToken(g))
    // g.$store.commit('change', refreshToken.value)

    // if (!g.$cookies.get("username"))
    //   window.location.href = "https://jakaset.jakarta.go.id";

    const nama = ref(g.$cookies.get('username'))
    const unit = ref(g.$cookies.get('nalok'))
    const tempKib = g.$cookies.get('kib') || 'B'
    const kib = ref(tempKib.toLowerCase())

    const getTahunSensus = () => apiReferensi.getTahunSensus(g, { kib: kib.value })

    const changeKib = async value => {
      if(value === 'i' || value === 'e'){
        // console.log(value)
        kib.value = 'b'
        g.$cookies.get('kib') || 'B'
        window.open('https://jakaset.jakarta.go.id/inventarisasi/ei/pr/client/', '_blank')
      }
      else{
        const result = await getTahunSensus()
        // console.log(value)
        g.$cookies.set('listTahun', JSON.stringify(result?.rows))
        g.$cookies.set('kib', value.toUpperCase())
        if (process.env.VUE_APP_ENV == 'development') window.location.href = `/${value}`
        else if (process.env.VUE_APP_ENV == 'staging') window.location.href = `/inventarisasi/st/${value}`
        else window.location.href = `/inventarisasi/pr/${value}`
      }
    }

    getTahunSensus()

    return {
      nama,
      unit,
      kib,
      changeKib,
    }
  },
  metaInfo() {
    return {
      titleTemplate: `${this.$route.meta.pageTitle} | %s`,
    }
  },
}
</script>
